import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
import { FormsModule, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
declare var jslib;
@Component({
  selector: 'contactEdit-component',
  templateUrl: './contactEdit.component.html'
})
export class ContactEditComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer
  ) {
    super();
  }
  ngOnInit() {
    this.mainForm = new FormGroup({
      name: new FormControl(''),
      englishName: new FormControl(''),
      email: new FormControl(''),
      mobile : new FormControl(''),
      tel: new FormControl(''),
      //edit only
      url: new FormControl('', [Validators.required,Validators.maxLength(250)]),
      product: new FormControl('', [Validators.required,Validators.maxLength(500)]),
      productEn: new FormControl('', [Validators.required,Validators.maxLength(1000)]),
    });
    this.Submit();
  }
  public Data;
  Submit(){
    this.baseApi.apiGet('v1/member/companyUser',{}).then((res:any)=>{
      console.log('companyUser!',res);
      this.Data = res;
      //Auto Set Self
      var user = jslib.GetStorage('user');
      var self = res.find((item)=>{
        return item['email'] == user['account'];
      })
      if(self){
        this.SetMember(self);
      }
    });
  }
  SetMember(member){
    this.IsEdit = true;
    member['url'] = (member['url']) ? member['url'] : '';
    member['product'] = (member['product']) ? member['product'] : '';
    member['productEn'] = (member['productEn']) ? member['productEn'] : '';
    this.mainForm.reset(member);
  }
  public mainForm: FormGroup;
  public IsEdit = false;
  FormSubmit(){
    if(!this.mainForm.valid){
      return false;
    }
    var _data = this.mainForm.value;
    console.log('FormSubmit',_data);
          this.baseApi.apiPost('v1/member/companyProduct',_data).then((res)=>{
        this.pop.setConfirm({
          content:'公司資訊儲存成功',
          checkTxt:'確認',
          event:()=>{
            this.Submit();
          }
        });
      });
    //新增
    // if(this.IsEdit == false){
    //   this.baseApi.apiPut('v1/member/companyUser',_data).then((res)=>{
    //     this.pop.setConfirm({
    //       content:'公司資訊儲存成功',
    //       checkTxt:'確認',
    //       event:()=>{
    //         this.Submit();
    //       }
    //     });
    //   });
    // }else{
    //   this.baseApi.apiPost('v1/member/companyUser',_data).then((res)=>{
    //     this.pop.setConfirm({
    //       content:'公司資訊儲存成功',
    //       checkTxt:'確認',
    //       event:()=>{
    //         this.Submit();
    //       }
    //     });
    //   });
    // }
  }
  Reset(){
    this.mainForm.reset();
    this.IsEdit = false;
  }
}
